module.exports = {
	"version": "2.0",
	"metadata": {
		"apiVersion": "2015-10-01",
		"endpointPrefix": "gamelift",
		"jsonVersion": "1.1",
		"protocol": "json",
		"serviceFullName": "Amazon GameLift",
		"signatureVersion": "v4",
		"targetPrefix": "GameLift",
		"uid": "gamelift-2015-10-01"
	},
	"operations": {
		"AcceptMatch": {
			"input": {
				"type": "structure",
				"required": [
					"TicketId",
					"PlayerIds",
					"AcceptanceType"
				],
				"members": {
					"TicketId": {},
					"PlayerIds": {
						"type": "list",
						"member": {}
					},
					"AcceptanceType": {}
				}
			},
			"output": {
				"type": "structure",
				"members": {}
			}
		},
		"CreateAlias": {
			"input": {
				"type": "structure",
				"required": [
					"Name",
					"RoutingStrategy"
				],
				"members": {
					"Name": {},
					"Description": {},
					"RoutingStrategy": {
						"shape": "Sa"
					}
				}
			},
			"output": {
				"type": "structure",
				"members": {
					"Alias": {
						"shape": "Sf"
					}
				}
			}
		},
		"CreateBuild": {
			"input": {
				"type": "structure",
				"members": {
					"Name": {},
					"Version": {},
					"StorageLocation": {
						"shape": "Sk"
					},
					"OperatingSystem": {}
				}
			},
			"output": {
				"type": "structure",
				"members": {
					"Build": {
						"shape": "So"
					},
					"UploadCredentials": {
						"shape": "Ss"
					},
					"StorageLocation": {
						"shape": "Sk"
					}
				}
			}
		},
		"CreateFleet": {
			"input": {
				"type": "structure",
				"required": [
					"Name",
					"BuildId",
					"EC2InstanceType"
				],
				"members": {
					"Name": {},
					"Description": {},
					"BuildId": {},
					"ServerLaunchPath": {},
					"ServerLaunchParameters": {},
					"LogPaths": {
						"shape": "Su"
					},
					"EC2InstanceType": {},
					"EC2InboundPermissions": {
						"shape": "Sw"
					},
					"NewGameSessionProtectionPolicy": {},
					"RuntimeConfiguration": {
						"shape": "S12"
					},
					"ResourceCreationLimitPolicy": {
						"shape": "S18"
					},
					"MetricGroups": {
						"shape": "S1a"
					}
				}
			},
			"output": {
				"type": "structure",
				"members": {
					"FleetAttributes": {
						"shape": "S1d"
					}
				}
			}
		},
		"CreateGameSession": {
			"input": {
				"type": "structure",
				"required": [
					"MaximumPlayerSessionCount"
				],
				"members": {
					"FleetId": {},
					"AliasId": {},
					"MaximumPlayerSessionCount": {
						"type": "integer"
					},
					"Name": {},
					"GameProperties": {
						"shape": "S1g"
					},
					"CreatorId": {},
					"GameSessionId": {},
					"IdempotencyToken": {},
					"GameSessionData": {}
				}
			},
			"output": {
				"type": "structure",
				"members": {
					"GameSession": {
						"shape": "S1n"
					}
				}
			}
		},
		"CreateGameSessionQueue": {
			"input": {
				"type": "structure",
				"required": [
					"Name"
				],
				"members": {
					"Name": {},
					"TimeoutInSeconds": {
						"type": "integer"
					},
					"PlayerLatencyPolicies": {
						"shape": "S1t"
					},
					"Destinations": {
						"shape": "S1v"
					}
				}
			},
			"output": {
				"type": "structure",
				"members": {
					"GameSessionQueue": {
						"shape": "S1y"
					}
				}
			}
		},
		"CreateMatchmakingConfiguration": {
			"input": {
				"type": "structure",
				"required": [
					"Name",
					"GameSessionQueueArns",
					"RequestTimeoutSeconds",
					"AcceptanceRequired",
					"RuleSetName"
				],
				"members": {
					"Name": {},
					"Description": {},
					"GameSessionQueueArns": {
						"shape": "S20"
					},
					"RequestTimeoutSeconds": {
						"type": "integer"
					},
					"AcceptanceTimeoutSeconds": {
						"type": "integer"
					},
					"AcceptanceRequired": {
						"type": "boolean"
					},
					"RuleSetName": {},
					"NotificationTarget": {},
					"AdditionalPlayerCount": {
						"type": "integer"
					},
					"CustomEventData": {},
					"GameProperties": {
						"shape": "S1g"
					},
					"GameSessionData": {}
				}
			},
			"output": {
				"type": "structure",
				"members": {
					"Configuration": {
						"shape": "S27"
					}
				}
			}
		},
		"CreateMatchmakingRuleSet": {
			"input": {
				"type": "structure",
				"required": [
					"Name",
					"RuleSetBody"
				],
				"members": {
					"Name": {},
					"RuleSetBody": {}
				}
			},
			"output": {
				"type": "structure",
				"required": [
					"RuleSet"
				],
				"members": {
					"RuleSet": {
						"shape": "S2b"
					}
				}
			}
		},
		"CreatePlayerSession": {
			"input": {
				"type": "structure",
				"required": [
					"GameSessionId",
					"PlayerId"
				],
				"members": {
					"GameSessionId": {},
					"PlayerId": {},
					"PlayerData": {}
				}
			},
			"output": {
				"type": "structure",
				"members": {
					"PlayerSession": {
						"shape": "S2f"
					}
				}
			}
		},
		"CreatePlayerSessions": {
			"input": {
				"type": "structure",
				"required": [
					"GameSessionId",
					"PlayerIds"
				],
				"members": {
					"GameSessionId": {},
					"PlayerIds": {
						"type": "list",
						"member": {}
					},
					"PlayerDataMap": {
						"type": "map",
						"key": {},
						"value": {}
					}
				}
			},
			"output": {
				"type": "structure",
				"members": {
					"PlayerSessions": {
						"shape": "S2m"
					}
				}
			}
		},
		"DeleteAlias": {
			"input": {
				"type": "structure",
				"required": [
					"AliasId"
				],
				"members": {
					"AliasId": {}
				}
			}
		},
		"DeleteBuild": {
			"input": {
				"type": "structure",
				"required": [
					"BuildId"
				],
				"members": {
					"BuildId": {}
				}
			}
		},
		"DeleteFleet": {
			"input": {
				"type": "structure",
				"required": [
					"FleetId"
				],
				"members": {
					"FleetId": {}
				}
			}
		},
		"DeleteGameSessionQueue": {
			"input": {
				"type": "structure",
				"required": [
					"Name"
				],
				"members": {
					"Name": {}
				}
			},
			"output": {
				"type": "structure",
				"members": {}
			}
		},
		"DeleteMatchmakingConfiguration": {
			"input": {
				"type": "structure",
				"required": [
					"Name"
				],
				"members": {
					"Name": {}
				}
			},
			"output": {
				"type": "structure",
				"members": {}
			}
		},
		"DeleteScalingPolicy": {
			"input": {
				"type": "structure",
				"required": [
					"Name",
					"FleetId"
				],
				"members": {
					"Name": {},
					"FleetId": {}
				}
			}
		},
		"DescribeAlias": {
			"input": {
				"type": "structure",
				"required": [
					"AliasId"
				],
				"members": {
					"AliasId": {}
				}
			},
			"output": {
				"type": "structure",
				"members": {
					"Alias": {
						"shape": "Sf"
					}
				}
			}
		},
		"DescribeBuild": {
			"input": {
				"type": "structure",
				"required": [
					"BuildId"
				],
				"members": {
					"BuildId": {}
				}
			},
			"output": {
				"type": "structure",
				"members": {
					"Build": {
						"shape": "So"
					}
				}
			}
		},
		"DescribeEC2InstanceLimits": {
			"input": {
				"type": "structure",
				"members": {
					"EC2InstanceType": {}
				}
			},
			"output": {
				"type": "structure",
				"members": {
					"EC2InstanceLimits": {
						"type": "list",
						"member": {
							"type": "structure",
							"members": {
								"EC2InstanceType": {},
								"CurrentInstances": {
									"type": "integer"
								},
								"InstanceLimit": {
									"type": "integer"
								}
							}
						}
					}
				}
			}
		},
		"DescribeFleetAttributes": {
			"input": {
				"type": "structure",
				"members": {
					"FleetIds": {
						"shape": "S34"
					},
					"Limit": {
						"type": "integer"
					},
					"NextToken": {}
				}
			},
			"output": {
				"type": "structure",
				"members": {
					"FleetAttributes": {
						"type": "list",
						"member": {
							"shape": "S1d"
						}
					},
					"NextToken": {}
				}
			}
		},
		"DescribeFleetCapacity": {
			"input": {
				"type": "structure",
				"members": {
					"FleetIds": {
						"shape": "S34"
					},
					"Limit": {
						"type": "integer"
					},
					"NextToken": {}
				}
			},
			"output": {
				"type": "structure",
				"members": {
					"FleetCapacity": {
						"type": "list",
						"member": {
							"type": "structure",
							"members": {
								"FleetId": {},
								"InstanceType": {},
								"InstanceCounts": {
									"type": "structure",
									"members": {
										"DESIRED": {
											"type": "integer"
										},
										"MINIMUM": {
											"type": "integer"
										},
										"MAXIMUM": {
											"type": "integer"
										},
										"PENDING": {
											"type": "integer"
										},
										"ACTIVE": {
											"type": "integer"
										},
										"IDLE": {
											"type": "integer"
										},
										"TERMINATING": {
											"type": "integer"
										}
									}
								}
							}
						}
					},
					"NextToken": {}
				}
			}
		},
		"DescribeFleetEvents": {
			"input": {
				"type": "structure",
				"required": [
					"FleetId"
				],
				"members": {
					"FleetId": {},
					"StartTime": {
						"type": "timestamp"
					},
					"EndTime": {
						"type": "timestamp"
					},
					"Limit": {
						"type": "integer"
					},
					"NextToken": {}
				}
			},
			"output": {
				"type": "structure",
				"members": {
					"Events": {
						"type": "list",
						"member": {
							"type": "structure",
							"members": {
								"EventId": {},
								"ResourceId": {},
								"EventCode": {},
								"Message": {},
								"EventTime": {
									"type": "timestamp"
								},
								"PreSignedLogUrl": {}
							}
						}
					},
					"NextToken": {}
				}
			}
		},
		"DescribeFleetPortSettings": {
			"input": {
				"type": "structure",
				"required": [
					"FleetId"
				],
				"members": {
					"FleetId": {}
				}
			},
			"output": {
				"type": "structure",
				"members": {
					"InboundPermissions": {
						"shape": "Sw"
					}
				}
			}
		},
		"DescribeFleetUtilization": {
			"input": {
				"type": "structure",
				"members": {
					"FleetIds": {
						"shape": "S34"
					},
					"Limit": {
						"type": "integer"
					},
					"NextToken": {}
				}
			},
			"output": {
				"type": "structure",
				"members": {
					"FleetUtilization": {
						"type": "list",
						"member": {
							"type": "structure",
							"members": {
								"FleetId": {},
								"ActiveServerProcessCount": {
									"type": "integer"
								},
								"ActiveGameSessionCount": {
									"type": "integer"
								},
								"CurrentPlayerSessionCount": {
									"type": "integer"
								},
								"MaximumPlayerSessionCount": {
									"type": "integer"
								}
							}
						}
					},
					"NextToken": {}
				}
			}
		},
		"DescribeGameSessionDetails": {
			"input": {
				"type": "structure",
				"members": {
					"FleetId": {},
					"GameSessionId": {},
					"AliasId": {},
					"StatusFilter": {},
					"Limit": {
						"type": "integer"
					},
					"NextToken": {}
				}
			},
			"output": {
				"type": "structure",
				"members": {
					"GameSessionDetails": {
						"type": "list",
						"member": {
							"type": "structure",
							"members": {
								"GameSession": {
									"shape": "S1n"
								},
								"ProtectionPolicy": {}
							}
						}
					},
					"NextToken": {}
				}
			}
		},
		"DescribeGameSessionPlacement": {
			"input": {
				"type": "structure",
				"required": [
					"PlacementId"
				],
				"members": {
					"PlacementId": {}
				}
			},
			"output": {
				"type": "structure",
				"members": {
					"GameSessionPlacement": {
						"shape": "S3t"
					}
				}
			}
		},
		"DescribeGameSessionQueues": {
			"input": {
				"type": "structure",
				"members": {
					"Names": {
						"type": "list",
						"member": {}
					},
					"Limit": {
						"type": "integer"
					},
					"NextToken": {}
				}
			},
			"output": {
				"type": "structure",
				"members": {
					"GameSessionQueues": {
						"type": "list",
						"member": {
							"shape": "S1y"
						}
					},
					"NextToken": {}
				}
			}
		},
		"DescribeGameSessions": {
			"input": {
				"type": "structure",
				"members": {
					"FleetId": {},
					"GameSessionId": {},
					"AliasId": {},
					"StatusFilter": {},
					"Limit": {
						"type": "integer"
					},
					"NextToken": {}
				}
			},
			"output": {
				"type": "structure",
				"members": {
					"GameSessions": {
						"shape": "S46"
					},
					"NextToken": {}
				}
			}
		},
		"DescribeInstances": {
			"input": {
				"type": "structure",
				"required": [
					"FleetId"
				],
				"members": {
					"FleetId": {},
					"InstanceId": {},
					"Limit": {
						"type": "integer"
					},
					"NextToken": {}
				}
			},
			"output": {
				"type": "structure",
				"members": {
					"Instances": {
						"type": "list",
						"member": {
							"type": "structure",
							"members": {
								"FleetId": {},
								"InstanceId": {},
								"IpAddress": {},
								"OperatingSystem": {},
								"Type": {},
								"Status": {},
								"CreationTime": {
									"type": "timestamp"
								}
							}
						}
					},
					"NextToken": {}
				}
			}
		},
		"DescribeMatchmaking": {
			"input": {
				"type": "structure",
				"required": [
					"TicketIds"
				],
				"members": {
					"TicketIds": {
						"shape": "S4e"
					}
				}
			},
			"output": {
				"type": "structure",
				"members": {
					"TicketList": {
						"type": "list",
						"member": {
							"shape": "S4h"
						}
					}
				}
			}
		},
		"DescribeMatchmakingConfigurations": {
			"input": {
				"type": "structure",
				"members": {
					"Names": {
						"shape": "S4e"
					},
					"RuleSetName": {},
					"Limit": {
						"type": "integer"
					},
					"NextToken": {}
				}
			},
			"output": {
				"type": "structure",
				"members": {
					"Configurations": {
						"type": "list",
						"member": {
							"shape": "S27"
						}
					},
					"NextToken": {}
				}
			}
		},
		"DescribeMatchmakingRuleSets": {
			"input": {
				"type": "structure",
				"members": {
					"Names": {
						"type": "list",
						"member": {}
					},
					"Limit": {
						"type": "integer"
					},
					"NextToken": {}
				}
			},
			"output": {
				"type": "structure",
				"required": [
					"RuleSets"
				],
				"members": {
					"RuleSets": {
						"type": "list",
						"member": {
							"shape": "S2b"
						}
					},
					"NextToken": {}
				}
			}
		},
		"DescribePlayerSessions": {
			"input": {
				"type": "structure",
				"members": {
					"GameSessionId": {},
					"PlayerId": {},
					"PlayerSessionId": {},
					"PlayerSessionStatusFilter": {},
					"Limit": {
						"type": "integer"
					},
					"NextToken": {}
				}
			},
			"output": {
				"type": "structure",
				"members": {
					"PlayerSessions": {
						"shape": "S2m"
					},
					"NextToken": {}
				}
			}
		},
		"DescribeRuntimeConfiguration": {
			"input": {
				"type": "structure",
				"required": [
					"FleetId"
				],
				"members": {
					"FleetId": {}
				}
			},
			"output": {
				"type": "structure",
				"members": {
					"RuntimeConfiguration": {
						"shape": "S12"
					}
				}
			}
		},
		"DescribeScalingPolicies": {
			"input": {
				"type": "structure",
				"required": [
					"FleetId"
				],
				"members": {
					"FleetId": {},
					"StatusFilter": {},
					"Limit": {
						"type": "integer"
					},
					"NextToken": {}
				}
			},
			"output": {
				"type": "structure",
				"members": {
					"ScalingPolicies": {
						"type": "list",
						"member": {
							"type": "structure",
							"members": {
								"FleetId": {},
								"Name": {},
								"Status": {},
								"ScalingAdjustment": {
									"type": "integer"
								},
								"ScalingAdjustmentType": {},
								"ComparisonOperator": {},
								"Threshold": {
									"type": "double"
								},
								"EvaluationPeriods": {
									"type": "integer"
								},
								"MetricName": {}
							}
						}
					},
					"NextToken": {}
				}
			}
		},
		"GetGameSessionLogUrl": {
			"input": {
				"type": "structure",
				"required": [
					"GameSessionId"
				],
				"members": {
					"GameSessionId": {}
				}
			},
			"output": {
				"type": "structure",
				"members": {
					"PreSignedUrl": {}
				}
			}
		},
		"GetInstanceAccess": {
			"input": {
				"type": "structure",
				"required": [
					"FleetId",
					"InstanceId"
				],
				"members": {
					"FleetId": {},
					"InstanceId": {}
				}
			},
			"output": {
				"type": "structure",
				"members": {
					"InstanceAccess": {
						"type": "structure",
						"members": {
							"FleetId": {},
							"InstanceId": {},
							"IpAddress": {},
							"OperatingSystem": {},
							"Credentials": {
								"type": "structure",
								"members": {
									"UserName": {},
									"Secret": {}
								},
								"sensitive": true
							}
						}
					}
				}
			}
		},
		"ListAliases": {
			"input": {
				"type": "structure",
				"members": {
					"RoutingStrategyType": {},
					"Name": {},
					"Limit": {
						"type": "integer"
					},
					"NextToken": {}
				}
			},
			"output": {
				"type": "structure",
				"members": {
					"Aliases": {
						"type": "list",
						"member": {
							"shape": "Sf"
						}
					},
					"NextToken": {}
				}
			}
		},
		"ListBuilds": {
			"input": {
				"type": "structure",
				"members": {
					"Status": {},
					"Limit": {
						"type": "integer"
					},
					"NextToken": {}
				}
			},
			"output": {
				"type": "structure",
				"members": {
					"Builds": {
						"type": "list",
						"member": {
							"shape": "So"
						}
					},
					"NextToken": {}
				}
			}
		},
		"ListFleets": {
			"input": {
				"type": "structure",
				"members": {
					"BuildId": {},
					"Limit": {
						"type": "integer"
					},
					"NextToken": {}
				}
			},
			"output": {
				"type": "structure",
				"members": {
					"FleetIds": {
						"shape": "S34"
					},
					"NextToken": {}
				}
			}
		},
		"PutScalingPolicy": {
			"input": {
				"type": "structure",
				"required": [
					"Name",
					"FleetId",
					"ScalingAdjustment",
					"ScalingAdjustmentType",
					"Threshold",
					"ComparisonOperator",
					"EvaluationPeriods",
					"MetricName"
				],
				"members": {
					"Name": {},
					"FleetId": {},
					"ScalingAdjustment": {
						"type": "integer"
					},
					"ScalingAdjustmentType": {},
					"Threshold": {
						"type": "double"
					},
					"ComparisonOperator": {},
					"EvaluationPeriods": {
						"type": "integer"
					},
					"MetricName": {}
				}
			},
			"output": {
				"type": "structure",
				"members": {
					"Name": {}
				}
			}
		},
		"RequestUploadCredentials": {
			"input": {
				"type": "structure",
				"required": [
					"BuildId"
				],
				"members": {
					"BuildId": {}
				}
			},
			"output": {
				"type": "structure",
				"members": {
					"UploadCredentials": {
						"shape": "Ss"
					},
					"StorageLocation": {
						"shape": "Sk"
					}
				}
			}
		},
		"ResolveAlias": {
			"input": {
				"type": "structure",
				"required": [
					"AliasId"
				],
				"members": {
					"AliasId": {}
				}
			},
			"output": {
				"type": "structure",
				"members": {
					"FleetId": {}
				}
			}
		},
		"SearchGameSessions": {
			"input": {
				"type": "structure",
				"members": {
					"FleetId": {},
					"AliasId": {},
					"FilterExpression": {},
					"SortExpression": {},
					"Limit": {
						"type": "integer"
					},
					"NextToken": {}
				}
			},
			"output": {
				"type": "structure",
				"members": {
					"GameSessions": {
						"shape": "S46"
					},
					"NextToken": {}
				}
			}
		},
		"StartGameSessionPlacement": {
			"input": {
				"type": "structure",
				"required": [
					"PlacementId",
					"GameSessionQueueName",
					"MaximumPlayerSessionCount"
				],
				"members": {
					"PlacementId": {},
					"GameSessionQueueName": {},
					"GameProperties": {
						"shape": "S1g"
					},
					"MaximumPlayerSessionCount": {
						"type": "integer"
					},
					"GameSessionName": {},
					"PlayerLatencies": {
						"shape": "S3v"
					},
					"DesiredPlayerSessions": {
						"type": "list",
						"member": {
							"type": "structure",
							"members": {
								"PlayerId": {},
								"PlayerData": {}
							}
						}
					},
					"GameSessionData": {}
				}
			},
			"output": {
				"type": "structure",
				"members": {
					"GameSessionPlacement": {
						"shape": "S3t"
					}
				}
			}
		},
		"StartMatchmaking": {
			"input": {
				"type": "structure",
				"required": [
					"ConfigurationName",
					"Players"
				],
				"members": {
					"TicketId": {},
					"ConfigurationName": {},
					"Players": {
						"shape": "S4k"
					}
				}
			},
			"output": {
				"type": "structure",
				"members": {
					"MatchmakingTicket": {
						"shape": "S4h"
					}
				}
			}
		},
		"StopGameSessionPlacement": {
			"input": {
				"type": "structure",
				"required": [
					"PlacementId"
				],
				"members": {
					"PlacementId": {}
				}
			},
			"output": {
				"type": "structure",
				"members": {
					"GameSessionPlacement": {
						"shape": "S3t"
					}
				}
			}
		},
		"StopMatchmaking": {
			"input": {
				"type": "structure",
				"required": [
					"TicketId"
				],
				"members": {
					"TicketId": {}
				}
			},
			"output": {
				"type": "structure",
				"members": {}
			}
		},
		"UpdateAlias": {
			"input": {
				"type": "structure",
				"required": [
					"AliasId"
				],
				"members": {
					"AliasId": {},
					"Name": {},
					"Description": {},
					"RoutingStrategy": {
						"shape": "Sa"
					}
				}
			},
			"output": {
				"type": "structure",
				"members": {
					"Alias": {
						"shape": "Sf"
					}
				}
			}
		},
		"UpdateBuild": {
			"input": {
				"type": "structure",
				"required": [
					"BuildId"
				],
				"members": {
					"BuildId": {},
					"Name": {},
					"Version": {}
				}
			},
			"output": {
				"type": "structure",
				"members": {
					"Build": {
						"shape": "So"
					}
				}
			}
		},
		"UpdateFleetAttributes": {
			"input": {
				"type": "structure",
				"required": [
					"FleetId"
				],
				"members": {
					"FleetId": {},
					"Name": {},
					"Description": {},
					"NewGameSessionProtectionPolicy": {},
					"ResourceCreationLimitPolicy": {
						"shape": "S18"
					},
					"MetricGroups": {
						"shape": "S1a"
					}
				}
			},
			"output": {
				"type": "structure",
				"members": {
					"FleetId": {}
				}
			}
		},
		"UpdateFleetCapacity": {
			"input": {
				"type": "structure",
				"required": [
					"FleetId"
				],
				"members": {
					"FleetId": {},
					"DesiredInstances": {
						"type": "integer"
					},
					"MinSize": {
						"type": "integer"
					},
					"MaxSize": {
						"type": "integer"
					}
				}
			},
			"output": {
				"type": "structure",
				"members": {
					"FleetId": {}
				}
			}
		},
		"UpdateFleetPortSettings": {
			"input": {
				"type": "structure",
				"required": [
					"FleetId"
				],
				"members": {
					"FleetId": {},
					"InboundPermissionAuthorizations": {
						"shape": "Sw"
					},
					"InboundPermissionRevocations": {
						"shape": "Sw"
					}
				}
			},
			"output": {
				"type": "structure",
				"members": {
					"FleetId": {}
				}
			}
		},
		"UpdateGameSession": {
			"input": {
				"type": "structure",
				"required": [
					"GameSessionId"
				],
				"members": {
					"GameSessionId": {},
					"MaximumPlayerSessionCount": {
						"type": "integer"
					},
					"Name": {},
					"PlayerSessionCreationPolicy": {},
					"ProtectionPolicy": {}
				}
			},
			"output": {
				"type": "structure",
				"members": {
					"GameSession": {
						"shape": "S1n"
					}
				}
			}
		},
		"UpdateGameSessionQueue": {
			"input": {
				"type": "structure",
				"required": [
					"Name"
				],
				"members": {
					"Name": {},
					"TimeoutInSeconds": {
						"type": "integer"
					},
					"PlayerLatencyPolicies": {
						"shape": "S1t"
					},
					"Destinations": {
						"shape": "S1v"
					}
				}
			},
			"output": {
				"type": "structure",
				"members": {
					"GameSessionQueue": {
						"shape": "S1y"
					}
				}
			}
		},
		"UpdateMatchmakingConfiguration": {
			"input": {
				"type": "structure",
				"required": [
					"Name"
				],
				"members": {
					"Name": {},
					"Description": {},
					"GameSessionQueueArns": {
						"shape": "S20"
					},
					"RequestTimeoutSeconds": {
						"type": "integer"
					},
					"AcceptanceTimeoutSeconds": {
						"type": "integer"
					},
					"AcceptanceRequired": {
						"type": "boolean"
					},
					"RuleSetName": {},
					"NotificationTarget": {},
					"AdditionalPlayerCount": {
						"type": "integer"
					},
					"CustomEventData": {},
					"GameProperties": {
						"shape": "S1g"
					},
					"GameSessionData": {}
				}
			},
			"output": {
				"type": "structure",
				"members": {
					"Configuration": {
						"shape": "S27"
					}
				}
			}
		},
		"UpdateRuntimeConfiguration": {
			"input": {
				"type": "structure",
				"required": [
					"FleetId",
					"RuntimeConfiguration"
				],
				"members": {
					"FleetId": {},
					"RuntimeConfiguration": {
						"shape": "S12"
					}
				}
			},
			"output": {
				"type": "structure",
				"members": {
					"RuntimeConfiguration": {
						"shape": "S12"
					}
				}
			}
		},
		"ValidateMatchmakingRuleSet": {
			"input": {
				"type": "structure",
				"required": [
					"RuleSetBody"
				],
				"members": {
					"RuleSetBody": {}
				}
			},
			"output": {
				"type": "structure",
				"members": {
					"Valid": {
						"type": "boolean"
					}
				}
			}
		}
	},
	"shapes": {
		"Sa": {
			"type": "structure",
			"members": {
				"Type": {},
				"FleetId": {},
				"Message": {}
			}
		},
		"Sf": {
			"type": "structure",
			"members": {
				"AliasId": {},
				"Name": {},
				"AliasArn": {},
				"Description": {},
				"RoutingStrategy": {
					"shape": "Sa"
				},
				"CreationTime": {
					"type": "timestamp"
				},
				"LastUpdatedTime": {
					"type": "timestamp"
				}
			}
		},
		"Sk": {
			"type": "structure",
			"members": {
				"Bucket": {},
				"Key": {},
				"RoleArn": {}
			}
		},
		"So": {
			"type": "structure",
			"members": {
				"BuildId": {},
				"Name": {},
				"Version": {},
				"Status": {},
				"SizeOnDisk": {
					"type": "long"
				},
				"OperatingSystem": {},
				"CreationTime": {
					"type": "timestamp"
				}
			}
		},
		"Ss": {
			"type": "structure",
			"members": {
				"AccessKeyId": {},
				"SecretAccessKey": {},
				"SessionToken": {}
			},
			"sensitive": true
		},
		"Su": {
			"type": "list",
			"member": {}
		},
		"Sw": {
			"type": "list",
			"member": {
				"type": "structure",
				"required": [
					"FromPort",
					"ToPort",
					"IpRange",
					"Protocol"
				],
				"members": {
					"FromPort": {
						"type": "integer"
					},
					"ToPort": {
						"type": "integer"
					},
					"IpRange": {},
					"Protocol": {}
				}
			}
		},
		"S12": {
			"type": "structure",
			"members": {
				"ServerProcesses": {
					"type": "list",
					"member": {
						"type": "structure",
						"required": [
							"LaunchPath",
							"ConcurrentExecutions"
						],
						"members": {
							"LaunchPath": {},
							"Parameters": {},
							"ConcurrentExecutions": {
								"type": "integer"
							}
						}
					}
				},
				"MaxConcurrentGameSessionActivations": {
					"type": "integer"
				},
				"GameSessionActivationTimeoutSeconds": {
					"type": "integer"
				}
			}
		},
		"S18": {
			"type": "structure",
			"members": {
				"NewGameSessionsPerCreator": {
					"type": "integer"
				},
				"PolicyPeriodInMinutes": {
					"type": "integer"
				}
			}
		},
		"S1a": {
			"type": "list",
			"member": {}
		},
		"S1d": {
			"type": "structure",
			"members": {
				"FleetId": {},
				"FleetArn": {},
				"Description": {},
				"Name": {},
				"CreationTime": {
					"type": "timestamp"
				},
				"TerminationTime": {
					"type": "timestamp"
				},
				"Status": {},
				"BuildId": {},
				"ServerLaunchPath": {},
				"ServerLaunchParameters": {},
				"LogPaths": {
					"shape": "Su"
				},
				"NewGameSessionProtectionPolicy": {},
				"OperatingSystem": {},
				"ResourceCreationLimitPolicy": {
					"shape": "S18"
				},
				"MetricGroups": {
					"shape": "S1a"
				}
			}
		},
		"S1g": {
			"type": "list",
			"member": {
				"type": "structure",
				"required": [
					"Key",
					"Value"
				],
				"members": {
					"Key": {},
					"Value": {}
				}
			}
		},
		"S1n": {
			"type": "structure",
			"members": {
				"GameSessionId": {},
				"Name": {},
				"FleetId": {},
				"CreationTime": {
					"type": "timestamp"
				},
				"TerminationTime": {
					"type": "timestamp"
				},
				"CurrentPlayerSessionCount": {
					"type": "integer"
				},
				"MaximumPlayerSessionCount": {
					"type": "integer"
				},
				"Status": {},
				"GameProperties": {
					"shape": "S1g"
				},
				"IpAddress": {},
				"Port": {
					"type": "integer"
				},
				"PlayerSessionCreationPolicy": {},
				"CreatorId": {},
				"GameSessionData": {}
			}
		},
		"S1t": {
			"type": "list",
			"member": {
				"type": "structure",
				"members": {
					"MaximumIndividualPlayerLatencyMilliseconds": {
						"type": "integer"
					},
					"PolicyDurationSeconds": {
						"type": "integer"
					}
				}
			}
		},
		"S1v": {
			"type": "list",
			"member": {
				"type": "structure",
				"members": {
					"DestinationArn": {}
				}
			}
		},
		"S1y": {
			"type": "structure",
			"members": {
				"Name": {},
				"GameSessionQueueArn": {},
				"TimeoutInSeconds": {
					"type": "integer"
				},
				"PlayerLatencyPolicies": {
					"shape": "S1t"
				},
				"Destinations": {
					"shape": "S1v"
				}
			}
		},
		"S20": {
			"type": "list",
			"member": {}
		},
		"S27": {
			"type": "structure",
			"members": {
				"Name": {},
				"Description": {},
				"GameSessionQueueArns": {
					"shape": "S20"
				},
				"RequestTimeoutSeconds": {
					"type": "integer"
				},
				"AcceptanceTimeoutSeconds": {
					"type": "integer"
				},
				"AcceptanceRequired": {
					"type": "boolean"
				},
				"RuleSetName": {},
				"NotificationTarget": {},
				"AdditionalPlayerCount": {
					"type": "integer"
				},
				"CustomEventData": {},
				"CreationTime": {
					"type": "timestamp"
				},
				"GameProperties": {
					"shape": "S1g"
				},
				"GameSessionData": {}
			}
		},
		"S2b": {
			"type": "structure",
			"required": [
				"RuleSetBody"
			],
			"members": {
				"RuleSetName": {},
				"RuleSetBody": {},
				"CreationTime": {
					"type": "timestamp"
				}
			}
		},
		"S2f": {
			"type": "structure",
			"members": {
				"PlayerSessionId": {},
				"PlayerId": {},
				"GameSessionId": {},
				"FleetId": {},
				"CreationTime": {
					"type": "timestamp"
				},
				"TerminationTime": {
					"type": "timestamp"
				},
				"Status": {},
				"IpAddress": {},
				"Port": {
					"type": "integer"
				},
				"PlayerData": {}
			}
		},
		"S2m": {
			"type": "list",
			"member": {
				"shape": "S2f"
			}
		},
		"S34": {
			"type": "list",
			"member": {}
		},
		"S3t": {
			"type": "structure",
			"members": {
				"PlacementId": {},
				"GameSessionQueueName": {},
				"Status": {},
				"GameProperties": {
					"shape": "S1g"
				},
				"MaximumPlayerSessionCount": {
					"type": "integer"
				},
				"GameSessionName": {},
				"GameSessionId": {},
				"GameSessionArn": {},
				"GameSessionRegion": {},
				"PlayerLatencies": {
					"shape": "S3v"
				},
				"StartTime": {
					"type": "timestamp"
				},
				"EndTime": {
					"type": "timestamp"
				},
				"IpAddress": {},
				"Port": {
					"type": "integer"
				},
				"PlacedPlayerSessions": {
					"type": "list",
					"member": {
						"type": "structure",
						"members": {
							"PlayerId": {},
							"PlayerSessionId": {}
						}
					}
				},
				"GameSessionData": {}
			}
		},
		"S3v": {
			"type": "list",
			"member": {
				"type": "structure",
				"members": {
					"PlayerId": {},
					"RegionIdentifier": {},
					"LatencyInMilliseconds": {
						"type": "float"
					}
				}
			}
		},
		"S46": {
			"type": "list",
			"member": {
				"shape": "S1n"
			}
		},
		"S4e": {
			"type": "list",
			"member": {}
		},
		"S4h": {
			"type": "structure",
			"members": {
				"TicketId": {},
				"ConfigurationName": {},
				"Status": {},
				"StatusReason": {},
				"StatusMessage": {},
				"StartTime": {
					"type": "timestamp"
				},
				"Players": {
					"shape": "S4k"
				},
				"GameSessionConnectionInfo": {
					"type": "structure",
					"members": {
						"GameSessionArn": {},
						"IpAddress": {},
						"Port": {
							"type": "integer"
						},
						"MatchedPlayerSessions": {
							"type": "list",
							"member": {
								"type": "structure",
								"members": {
									"PlayerId": {},
									"PlayerSessionId": {}
								}
							}
						}
					}
				}
			}
		},
		"S4k": {
			"type": "list",
			"member": {
				"type": "structure",
				"members": {
					"PlayerId": {},
					"PlayerAttributes": {
						"type": "map",
						"key": {},
						"value": {
							"type": "structure",
							"members": {
								"S": {},
								"N": {
									"type": "double"
								},
								"SL": {
									"shape": "Su"
								},
								"SDM": {
									"type": "map",
									"key": {},
									"value": {
										"type": "double"
									}
								}
							}
						}
					},
					"Team": {},
					"LatencyInMs": {
						"type": "map",
						"key": {},
						"value": {
							"type": "integer"
						}
					}
				}
			}
		}
	}
};


//////////////////
// WEBPACK FOOTER
// ./~/aws-sdk/apis/gamelift-2015-10-01.min.json
// module id = 630
// module chunks = 0